import { useLang } from 'hooks/lang';

import { isImageFile, loaders, TaskFile } from 'entities';

import { Card, Column, Grid, Label, Row, Skeleton } from 'components/Blocks';
import { PrivateImage } from 'components/Uploads';
import { TruncateText } from 'components/TruncateText';
import { DownloadFileButton } from 'components/Buttons';

import { useProjectProfile } from '../../context';

import { listGet } from 'utils/array';
import { FileVersionTag } from '../../FileHistoryTag';
import { isSubstring } from 'utils/text';

export function TaskFiles({ fileQuery }: { fileQuery: string }) {
  const { t } = useLang();

  const { id, project, openTask } = useProjectProfile();

  const [taskFiles, { errorOrLoading }] = loaders.projects.allProjectFiles.useV2({
    defaultValue: [],

    params: { projectId: id },

    parser: (allFiles) => allFiles.filter((f) => 'task' in f),
  });

  const toRenderFiles = (taskFiles as TaskFile[]).filter((f) =>
    isSubstring(fileQuery.trim(), f.name),
  );

  return (
    <Column>
      <Label>{t('task-files')}</Label>

      {errorOrLoading && <Skeleton wrapMultiple={false} height={48} quantity={4} />}

      <Grid cols="auto-fit" colWidth={250}>
        {toRenderFiles
          .filter((f) => !isImageFile(f))
          .map((file) => (
            <Card key={file.id}>
              <Column gap="1">
                <button
                  className="w-fit text-xs font-medium hover:underline"
                  onClick={() => openTask(file.task)}
                >
                  {listGet(project.tasks, file.task)!.name}
                </button>

                <TruncateText max={30} className="font-semibold text-primary" text={file.name} />

                <Row gap="2" justifyContent="space-between">
                  <FileVersionTag file={file} />
                  <DownloadFileButton {...file} size={12} />
                </Row>
              </Column>
            </Card>
          ))}

        {toRenderFiles.filter(isImageFile).map((file) => (
          <PrivateImage key={file.url} {...file} className="h-28 border" />
        ))}
      </Grid>
    </Column>
  );
}
